export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const UPDATE_PROFILE_ACTION = '[Update profile action] Update profile action';
export const DELETE_PROFILE_ACTION = '[DELETE_PROFILE_ACTION action] DELETE_PROFILE_ACTION action';
export const SWITCH_THEME = '[SWITCH_THEME action] SWITCH_THEME action';
export const USER_LOCATION = '[USER_LOCATION action] USER_LOCATION action';
export const INCREMENT_MAP = '[INCREMENT_MAP action] INCREMENT_MAP action'; 